export default "__VITE_ASSET__HMimgg8v__"